var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisualInspection3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.89254 7.15402L9 4.16116L10.1075 7.15402L10.8108 6.89374L10.1075 7.15402C10.2341 7.49617 10.5038 7.76593 10.846 7.89254L13.8388 9L10.846 10.1075C10.5038 10.2341 10.2341 10.5038 10.1075 10.846L9 13.8388L7.89254 10.846C7.76593 10.5038 7.49617 10.2341 7.15402 10.1075L6.89374 10.8108L7.15402 10.1075L4.16116 9L7.15402 7.89254C7.49617 7.76593 7.76593 7.49617 7.89254 7.15402ZM3.52753 8.76554C3.52765 8.76558 3.52778 8.76563 3.5279 8.76567L3.52753 8.76554L3.44077 9L3.52753 8.76554ZM9.23434 3.52787L9.23446 3.52753L9 3.44077L9.23446 3.52753C9.23442 3.52764 9.23438 3.52776 9.23434 3.52787Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4327 15.6942L17 14.1612L17.5673 15.6942C17.6939 16.0364 17.9636 16.3061 18.3058 16.4327L19.8388 17L18.3058 17.5673C17.9636 17.6939 17.6939 17.9636 17.5673 18.3058L17 19.8388L16.4327 18.3058C16.3061 17.9636 16.0364 17.6939 15.6942 17.5673L14.1612 17L15.6942 16.4327L15.4339 15.7293L15.6942 16.4327C16.0364 16.3061 16.3061 16.0364 16.4327 15.6942Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualInspection3);
export default __webpack_public_path__ + "static/media/visual-inspection3.749833cedce9b9afb062039910eabf6f.svg";
export { ForwardRef as ReactComponent };